import CliniciansList from './CliniciansList';

export default CliniciansList;
